var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StyledDiv',{staticClass:"fullPage"},[_c('Splash'),_c('Ph2SupplementContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }